<template>
    <div id="auth">
        <div class="login-section">
            <form class="form" @submit.prevent="sendForm">
                <img id="logo" src="@/assets/logo.svg" alt="" />
                <div class="form-group">
                    <label>Email</label>
                    <input data-cy="email" type="email" v-model="form.email" />
                    <has-error data-cy="email_error" :form="form" field="email"></has-error>
                </div>

                <div class="form-group">
                    <button
                        class="button dark"
                        :disabled="form.busy"
                        data-cy="submit"
                        type="submit"
                        name="button"
                    >
                        {{ form.busy ? "Please wait" : "Send password reset email" }}
                    </button>
                </div>
            </form>
            <div class="login-form-nav-links">
                <router-link to="login">Back to home</router-link>
            </div>
        </div>
    </div>
</template>

<script>
//import Cookie from 'js-cookie'
import { Form, HasError } from "vform";
export default {
    name: "login",
    components: { HasError },
    data() {
        return {
            form: new Form({
                email: "",
            }),
        };
    },
    methods: {
        sendForm() {
            this.form.post("/forgot").then(() => {
                alert("Weve sent you an email that will contain a link to reset your password");
                this.$router.push("/reset?email=" + encodeURIComponent(this.form.email));
            });
        },
    },
};
</script>

<style lang="less">
.form {
    .form-group {
        label {
            display: block;
        }
        input[type="text"],
        input[type="email"],
        input[type="password"] {
            width: 100%;
        }
    }
}
</style>
